import { Fragment, useMemo, useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { Button, Col, Collapse, Divider, Grid, Image, Row, Space, Tag, Typography } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import classNames from 'classnames';
import DOMPurify from 'isomorphic-dompurify';
import FilterAccordion from 'src/components/Filter/FilterAccordion';
// import messageC from 'src/components/Message';
// import ModalShare from 'src/components/Profile/InviteFriends/Share/ModalShare';
import g from 'src/constants/global';
// import defaultPagination from 'src/constants/pagination';
// import useInsiderTrackingArticle from 'src/hooks/useInsiderTrackingArticle';
import { ISection } from 'src/interface';
import deviceSizeC from 'src/utils/device-size-client';
import { formatDateListArticels, formatDateListArticelsMobile } from 'src/utils/func/format-date';
import { renderDetailArticle } from 'src/utils/func/render-article';
import layoutMobile from 'src/utils/layout-mobile';
import classes from './style.module.less';
import IconCustom from '@/components/Icon/Custom';
import { useMessageC } from '@/utils/useMessage';
const {
  Panel
} = Collapse;
const GPT = dynamic(() => import('src/components/GPT'), {
  ssr: false
});
const ArticleDetail = (props: any) => {
  const {
    xl,
    lg,
    xs
  } = Grid.useBreakpoint();
  const router = useRouter();
  const messageC = useMessageC();
  const lm = layoutMobile(router);
  const article = props;
  const url = `${process.env.NEXT_PUBLIC_WEB_URL}${router.asPath?.split('?')[0]}`;
  const copyLink = () => {
    const cb = navigator.clipboard;
    cb.writeText(`${window.location.origin}${router.asPath?.split('?')[0]}`).then(() => {
      messageC('Copied');
    });
  };
  const sosmed = {
    social_media: [{
      icon: '/images/default/logoFbColor.svg',
      name: 'Facebook',
      deeplink: `https://www.facebook.com/sharer/sharer.php?u=${url}`
    }, {
      icon: '/images/default/logoXColor.svg',
      name: 'Twitter',
      deeplink: `https://twitter.com/intent/tweet?url=${url}`
    }, {
      icon: '/images/default/logoWaColor.svg',
      name: 'WhatsApp',
      deeplink: `https://api.whatsapp.com/send?text=${url}`
    }, {
      icon: '/images/default/logoCopy.svg',
      name: 'copylink',
      deeplink: ''
    }]
  };
  // const [showModalShare, setShowModalShare] = useState(false);
  // const article: IArticleByGroupDetail = useSelector(
  // (state: RootStateOrAny) => state.articleByGroup.detail,
  // );
  const channel = article.categories?.length > 0 ? article.categories[0].full_slug.split('/') : [];

  // const copy = (text: any) => {
  // navigator.clipboard.writeText(text);
  // messageC('Tautan berhasil disalin');
  // };
  const breakpoint = Grid.useBreakpoint();
  const pageBreaks = useMemo(() => {
    return article?.sections?.filter((s: any) => s.type === 'PageBreakSection');
  }, [article]);
  const renderDivider = (section: ISection) => {
    return pageBreaks && pageBreaks.map((pb: any, index: any) => {
      if (pb.uid === section.uid) {
        return <Divider key={pb.uid} plain className={classes.divider}>
							{`${index + 1} dari ${pageBreaks.length}`}
						</Divider>;
      }
    });
  };
  const getContentArticleClass = (type: string) => {
    switch (type) {
      case 'TextSection':
        return '';
      case 'PageBreakSection':
        return classes['page-break-section'];
      default:
        return '';
    }
  };
  const [imageBroken, setImageBroken] = useState(String);
  const {
    toc,
    contentNodes
  } = useMemo(() => {
    if (!article?.sections?.[0]?.content) return {
      toc: [],
      contentNodes: []
    };
    const content = article.sections[0].content;
    const tocData: any[] = [];
    let currentH2: any = null;
    let index = 0;
    const nodeMatches = content.match(/<iframe[\s\S]*?<\/iframe>|<(p|h[1-6]|ul|ol|blockquote|table|figure)[^>]*>[\s\S]*?<\/\1>/gi) || [];
    const nodes = nodeMatches.map((node: string) => {
      const headingMatch = node.match(/^<(h2|h3)(\s[^>]*)?>[\s\S]*?<\/(h2|h3)>/i);
      if (!headingMatch) return node;
      const tag = headingMatch[1].toUpperCase();
      const text = node.replace(/<[^>]+>/g, '').trim();
      const id = `heading-${index++}`;
      const nodeWithId = node.replace(/^<(h2|h3)(\s[^>]*)?>/i, `<$1 id="${id}" class="article-heading">`);
      if (tag === 'H2') {
        const newItem = {
          id,
          text,
          children: []
        };
        tocData.push(newItem);
        currentH2 = newItem;
      } else if (tag === 'H3') {
        const item = {
          id,
          text
        };
        if (currentH2) currentH2.children.push(item);else tocData.push({
          ...item,
          children: []
        });
      }
      return nodeWithId;
    });
    return {
      toc: tocData,
      contentNodes: nodes
    };
  }, [article]);
  const scrollToId = (id: string) => {
    const el = document.getElementById(id);
    if (!el) return;
    const yOffset = -150;
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  };
  const [activeKey, setActiveKey] = useState<string[]>([]);
  const handleChange = (key: string | string[]) => {
    const keys = Array.isArray(key) ? key : [key];
    setActiveKey(keys.map(String));
  };
  const photoSections = article?.sections?.filter((s: ISection) => s.type === 'PhotoSection');
  const getBannerByPosition = (pos: string) => photoSections?.find((p: ISection) => p.media_title === pos);
  const renderBanner = (banner: ISection | undefined) => {
    if (!banner?.media_full_url) return null;
    const image = <Image src={banner.media_full_url} alt="banner" className={classes.bannerImage} preview={false} />;
    return <div className={classes.bannerWrapper}>
				{banner.content ? <a href={banner.content} target="_blank" rel="noreferrer">
						{image}
					</a> : image}
			</div>;
  };
  const total = contentNodes.length;
  const firstIndex = 2; // setelah p ke 2
  const middleIndex = Math.floor(total / 2);
  const lastIndex = total - 2;
  return <div className={classes['wrap-article-detail']} style={{
    marginRight: '20px'
  }}>
			<h1 className={classes.title}>{article.title}</h1>
			<Row>
				<Col className="d-flex align-items-center">
					<Typography className="fs-14 fs-md-16">
						{!article.author_name ? <span style={{
            color: '#F48A8A',
            fontWeight: '500'
          }}>Tim Ahli Hallobumil </span> : <a href={`/author/${article.author_slug}`}><span style={{
              color: '#F48A8A',
              fontWeight: '500'
            }}>{article.author_name} {' '}</span></a>}
						| Diterbitkan pada {xs ? formatDateListArticelsMobile(article.publish_date) : formatDateListArticels(article.publish_date)}
					</Typography>
				</Col>
			</Row>
			<Row>
				<Col className="d-flex align-items-center">
					<Typography className="fs-14 fs-md-16" style={{
          color: '#A19797'
        }}>
						Ditinjau oleh {!article.reviewer_name ? <span style={{
            color: '#4A4545',
            fontWeight: '500'
          }}>Tim Ahli Hallobumil </span> : <a href={`/author/${article.reviewer_slug}`}><span style={{
              color: '#4A4545',
              fontWeight: '500',
              textDecoration: 'underline'
            }}>{article.reviewer_name}</span></a>}
					</Typography>
				</Col>
			</Row>
			<Row style={{
      paddingTop: '20px',
      paddingBottom: '20px'
    }}>
				<Col md={16} xs={12}>
					{article.cmp_article_category?.find((x: any) => x.is_primary) && <Button className={classNames(classes.category, {
          [classes['category-mobile']]: lm
        })} style={{
          backgroundColor: '#ffffff',
          color: '#F48A8A',
          border: '1px solid #F48A8A'
        }} id={article.type === 'post-pregnancy' ? 'detail-artikel-pasca-kehamilan' : article.type === 'pre-pregnancy' ? 'detail-artikel-pra-kehamilan' : article.type === 'pregnancy' ? 'detail-artikel-kehamilan' : article.type === 'recipe' ? 'detail-artikel-resep' : 'detail-artikel-semua-topik'}>
							{article.category_name ? article.category_name : article.type === 'post-pregnancy' ? 'Pasca Kehamilan' : article.type === 'pre-pregnancy' ? 'Pra Kehamilan' : 'Kehamilan'}
						</Button>}
				</Col>
				<Col md={8} xs={0}>
					<Space className={classes.icons} size="middle">
						<Paragraph>
							<Typography className={classes.sosmed}>Bagikan</Typography>
						</Paragraph>
						{sosmed.social_media?.map((item: any) => {
            return item.name !== 'copylink' ? <Fragment key={item.name}>
									<a href={item.deeplink} rel="nofollow noreferrer" id={'detail-artikel-' + item.name} target="_blank">
										{item.icon && <Image key={item.name} className={classes['socmed-icon']} width={!xl && lg ? 28 : xs ? 16 : 32} height={!xl && lg ? 28 : xs ? 16 : 32} src={item.icon} alt={item.name} preview={false} style={{
                  cursor: 'pointer'
                }} />}
									</a>
								</Fragment> : <Fragment key={item.name}>
									<div onClick={copyLink} id="CopyLinkA" style={{
                width: '40px'
              }}>
										{item.icon && <Image key={item.name} className={classes['socmed-icon']} width={!xl && lg ? 28 : xs ? 16 : 32} height={!xl && lg ? 28 : xs ? 16 : 32} src={item.icon} alt={item.name} preview={false} style={{
                  cursor: 'pointer'
                }} />}
									</div>
								</Fragment>;
          })}
					</Space>
				</Col>
				{/* <Col md={1} xs={0}></Col> */}
			</Row>

			<Row>
				<Col className="d-flex align-items-center">
					<span className="fs-14 fs-md-16" style={{
          color: '#4A4545'
        }}>{article.short_desc}</span>
				</Col>
			</Row>
			<div className={classes['article-contents']}>
				<div style={{
        textAlign: 'center',
        paddingBottom: '24px'
      }}>
					<Image alt={article.slug} src={article?.media_images_new?.original === imageBroken ? 'images/default/no-image.svg' : article?.media_images_new?.original} className={classes.imageContainer} style={{
          borderRadius: '20px',
          objectFit: 'cover',
          // height: `${xs ? '230px' : '478px'}`,
          // width: `${xs ? '330px' : '850px'}`,
          marginBottom: '24px',
          marginTop: '8px'
        }} preview={false} onError={() => {
          setImageBroken(article.media_images?.original);
        }} width={xs ? '344px' : '750px'} height={xs ? '230px' : '422px'} loading='lazy' />
				</div>
				{toc.length >= 1 && <Collapse key={toc.length} defaultActiveKey={[]} expandIconPlacement='end' style={{
        marginBottom: '10px',
        borderRadius: '8px'
      }}>
						<Panel header="Daftar Isi Artikel" key="1">
							<ul>
								{toc.map(item => <li key={item.id} style={{
              color: '#0075c9'
            }}>
										{/* H2 */}
										<span onClick={() => scrollToId(item.id)} style={{
                cursor: 'pointer',
                color: '#0075c9',
                fontWeight: 600
              }}>
											{item.text}
										</span>

										{/* H3 */}
										{item.children?.length > 0 && <ul style={{
                paddingLeft: 0,
                marginTop: 4,
                marginLeft: '-5px'
              }}>
												{item.children.map((child: any) => <li key={child.id}>
														<span onClick={() => scrollToId(child.id)} style={{
                    cursor: 'pointer',
                    color: '#0075c9',
                    fontSize: 14
                  }}>
															{child.text}
														</span>
													</li>)}
											</ul>}
									</li>)}
							</ul>
						</Panel>
					</Collapse>}
				{article?.sections?.map((s: ISection, i: number) => {
        return <section key={s.uid}>
							{s.content && <div className={getContentArticleClass(s.type)}>
									{s.type === 'PageBreakSection' && renderDivider(s)}

									{i === 0 && contentNodes.map((paragraph: string, pi: number) => <Fragment key={pi}>

												{/* FIRST */}
												{pi === firstIndex && renderBanner(getBannerByPosition('first'))}

												{/* MIDDLE */}
												{pi === middleIndex && renderBanner(getBannerByPosition('middle'))}

												{/* LAST */}
												{pi === lastIndex && renderBanner(getBannerByPosition('last'))}

												{/* ADS */}
												{pi === 2 && deviceSizeC(breakpoint) === 'desktop' && <GPT name="gpt-ad-detail-general-article-leaderboard" adUnit={g.AD.DTL_ARTICLE_LEADERBOARD_UNIT} size={g.AD.DTL_ARTICLE_LEADERBOARD_SIZE} target={[['channel', channel], ['article_id', [article.uid]]]} style={{
                margin: '10px 0',
                overflow: 'hidden'
              }} />}

												{pi === 2 && deviceSizeC(breakpoint) === 'mobile' && <GPT name="gpt-ad-detail-general-article-mobile-mrec" adUnit={g.AD.DTL_ARTICLE_MOBILE_MEDIUMREC_UNIT} size={g.AD.DTL_ARTICLE_MOBILE_MEDIUMREC_SIZE} target={[['channel', channel], ['article_id', [article.uid]]]} style={{
                marginBottom: 10,
                overflow: 'hidden'
              }} />}

												{/* PARAGRAPH */}
												{/* {paragraph && (
             <div
             	className={classes['article-image']}
             	dangerouslySetInnerHTML={{
             	__html: `${renderDetailArticle(paragraph)}`,
             	}}
             />
             )} */}
												{paragraph && <div className={classes['article-image']} dangerouslySetInnerHTML={{
                __html: paragraph.includes('iframe') ? paragraph // langsung render tanpa renderDetailArticle
                : renderDetailArticle(paragraph)
              }} />}
											</Fragment>)}
									{i === 0 && renderBanner(getBannerByPosition('down'))}
								</div>}
						</section>;
      })}
				{article?.faq_articles && <div className={classes['faq-wrapper']}>
							<h2 className="faq-title">Pertanyaan Populer</h2>

							{/* <Collapse
        bordered={false}
        onChange={handleChange}
        expandIconPosition="end"
        className={classes['faq-collapse']}
        expandIcon={({ isActive }) =>
        isActive ? (
        	<IconCustom iconName="faq-active" />
        ) : (
        	<IconCustom iconName="faq-inactive" />
        )
        }
        >
        {article?.faq_articles?.map((item: any, index: any) => {
        const key = String(index);
        // console.log('active faq', activeKey.includes(key) ? 'active' : 'no')
        return (
        <Panel
        	key={key}
        	header={
        		<p className={activeKey.includes(key) ? classes['faq-question-active'] : classes['faq-question']}>
        			{item.question}
        		</p>
        	}
        	className={classes['faq-panel']}
        >
        	<div
        		className={classes['faq-answer']}
        		style={{ fontSize: '14px !important'}}
        		dangerouslySetInnerHTML={{ __html: item.answer }}
        	/>
        </Panel>
        );
        })}
        </Collapse> */}
							<Collapse bordered={false} onChange={handleChange} expandIconPosition="end" className={classes['faq-collapse']} expandIcon={({
          isActive
        }) => isActive ? <IconCustom iconName="faq-active" /> : <IconCustom iconName="faq-inactive" />} items={article?.faq_articles?.map((item: any, index: any) => {
          const key = String(index);
          return {
            key,
            label: <p className={activeKey.includes(key) ? classes['faq-question-active'] : classes['faq-question']}>
												{item.question}
											</p>,
            children: <div className={classes['faq-answer']} style={{
              fontSize: '14px !important'
            }} dangerouslySetInnerHTML={{
              __html: item.answer
            }} />,
            className: classes['faq-panel']
          };
        })} />
						</div>}
				<Row>
					{article.tags?.map((tag: any, index: any) => {
          return <Tag className={classes['tag-article']} key={index}>
								{tag.name}
							</Tag>;
        })}
				</Row>
				{article?.reference?.length > 12 && <div className={classes['accordion-reference']}>
						<FilterAccordion accordionHeader="Referensi" accordionKey="Referensi">
							<div dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(article.reference)
          }} />
						</FilterAccordion>
					</div>}
			</div>
		</div>;
};
export default ArticleDetail;